import React from 'react';
import Pic1 from '../../InstallImages/Modules/LG360W';


const link1 = <a href="https://www.dropbox.com/s/tljjqy8qk4vsu86/LG350-360Q1K-V5_V2_06102019.pdf?dl=0" rel="noopener noreferrer" target="_blank">Data Sheet</a>;

const link2 = <a href="https://www.lg.com/us/business/experience-solar/lg-neonr" rel="noopener noreferrer" target="_blank">LG NeON® R Site</a>;


const Module = () => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <p className="specsText">
                <h2>Great Visual Appearance</h2>
                LG Solar&#39;s NeON® R is a powerful solar module that provides premium performance. The NeON® R incorporates a cell structure without electrodes on the front to maximize light utilization and enhance reliability. Providing added value for the customer beyond efficiency, this module features an enhanced warranty, outstanding durability, solid performance in real-world conditions and aesthetic design suitable for roofs.
            </p>
            <p className="specsText">
                <h2>Roof Aesthetics</h2>
                LG NeON® R has been designed with aesthetics in mind: the lack of any electrodes on the front creates an improved, modern aesthetic.
            </p>
            <p className="specsText">
                <h2>Enhanced Product Warranty</h2>
                LG has extended the warranty of the NeON® R to 25 years including labor, which is top level in the industry.
            </p>
            <p className="specsText">
                <h2>Enhanced Performance Warranty</h2>
                LG NeON® R has an enhanced performance warranty. After 25 years, LG NeON® R is guaranteed at least 90.8% of initial performance.
            </p>
            <ul>
                <li className="specsText">{link1}</li>
                <li className="specsText">{link2}</li>
            </ul>
        </div>
    </div>
);

export default Module;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Panels/lg360W.js